import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../redux/actions/optionsActions";
import en from "../../misc/lang/en";
import esp from "../../misc/lang/esp";

const LangToggle = () => {
  const langCode = useSelector((store) => store.options.lang.code);
  const dispatch = useDispatch();

  const toggleLang = (e) => {
    e.preventDefault();
    if (langCode === "esp") {
      dispatch(setLanguage({ code: "en", data: en }));
    } else if (langCode === "en") {
      dispatch(setLanguage({ code: "esp", data: esp }));
    }
  };

  return (
    <>
      <a href="/" onClick={toggleLang}>
        {langCode === "esp" ? "EN" : "ESP"}
      </a>
    </>
  );
};

export default LangToggle;
